import AbstractService, {
  InterfacePartnerPartner,
  ServicePartnerPartner,
  ModelPartnerPartner
} from "./AbstractService";

/**
 * AuthService
 */
export default class PartnerPartnerService extends AbstractService implements InterfacePartnerPartner {
  /**
   * ServiceAuth
   */
  static service: ServicePartnerPartner;

  /**
   * constructor
   */
  constructor() {
    super();

    PartnerPartnerService.service = this.getApi().getServicePartnerPartner();
  }

  /**
   * create
   * @param PartnerPartner
   */
  create(PartnerPartner: ModelPartnerPartner): Promise<ModelPartnerPartner> {
    return PartnerPartnerService.service.create(PartnerPartner);
  }

  /**
   * getById
   * @param id
   */
  getById(id: string): Promise<ModelPartnerPartner> {
    return PartnerPartnerService.service.getById(id);
  }

  /**
   * update
   * @param id
   * @param PartnerPartner
   */
  update(id: string, PartnerPartner: ModelPartnerPartner): Promise<ModelPartnerPartner> {
    return PartnerPartnerService.service.update(id, PartnerPartner);
  }

  /**
   * getAllCustomers
   */
  getAllCustomers(): Promise<ModelPartnerPartner[]> {
    return PartnerPartnerService.service.getAllCustomers();
  }

  /**
   * getDatatableCustomers
   */
  getDatatableCustomers(tableParameter = {}): Promise<any> {
    return PartnerPartnerService.service.getDatatableCustomers(tableParameter);
  }

  /**
   * getAllSuppliers
   */
  getAllSuppliers(): Promise<ModelPartnerPartner[]> {
    return PartnerPartnerService.service.getAllSuppliers();
  }

  /**
   * getDatatableSuppliers
   */
  getDatatableSuppliers(tableParameter = {}): Promise<any> {
    return PartnerPartnerService.service.getDatatableSuppliers(tableParameter);
  }

  /**
   * getCompanyLogoUrl
   * @param hashId
   */
  getCompanyLogoUrl(hashId: string): string {
    return PartnerPartnerService.service.getCompanyLogoUrl(hashId);
  }

  /**
   * getApiParameterList
   * parameters the supplier's api class expects per module; not part of the
   * api package yet, so it goes through the raw http service
   * @param id
   */
  getApiParameterList(id: string): Promise<{ priceAndStock: string[]; productSearch: string[]; bulkStockExport: string[] }> {
    return PartnerPartnerService.service.getHttpService()
      .get(`/partnerpartner/${id}/apiParameterList`)
      .then((response: any) => response.data);
  }

  /**
   * getPluginCatalog
   * all available config plugins with type, module, descriptions and their
   * required data parameters
   */
  getPluginCatalog(): Promise<Array<{
    name: string;
    type: string;
    interlinkModulType: string;
    descriptionShort: string;
    descriptionLong: string;
    parameter: string[];
  }>> {
    return PartnerPartnerService.service.getHttpService()
      .get('/system/enum/plugins')
      .then((response: any) => response.data);
  }
}
